import { getImageUrl } from "@/utils";

export const TAB_BAR_LIST = [
  {
    text: "起卦",
    color: "#8E8E9F",
    activeColor: "#255DEA",
    image: getImageUrl("../assets/images/tabbar/home.jpg"),
    activeImage: getImageUrl("../assets/images/tabbar/home-active.jpg"),
    url: "/#/home",
  },
  {
    text: "学习",
    color: "#8E8E9F",
    activeColor: "#255DEA",
    image: getImageUrl("../assets/images/tabbar/bbs.png"),
    activeImage: getImageUrl("../assets/images/tabbar/bbs-active.png"),
    url: "/#/bbs",
  },
  {
    text: "问一问",
    color: "#8E8E9F",
    activeColor: "#255DEA",
    image: getImageUrl("../assets/images/tabbar/question.png"),
    activeImage: getImageUrl("../assets/images/tabbar/question-active.png"),
    url: "/#/question",
  },
  {
    text: "日历",
    color: "#8E8E9F",
    activeColor: "#255DEA",
    image: getImageUrl("../assets/images/tabbar/calendar.png"),
    activeImage: getImageUrl("../assets/images/tabbar/calendar-active.png"),
    url: "/#/calendar",
  },
  {
    text: "我的",
    color: "#8E8E9F",
    activeColor: "#255DEA",
    image: getImageUrl("../assets/images/tabbar/about.png"),
    activeImage: getImageUrl("../assets/images/tabbar/about-active.png"),
    url: "/#/about",
  },
];

export const LoadingPage = "/#/loading";
// export const HomePage = '/#/home'
export const HomePage = "/#/question";
export const AboutPage = "/#/about";

export const DateFormat = "YYYY-MM-DD";
export const DateFormatMinute = "YYYY-MM-DD HH:mm";
export const DateFormatTime = "YYYY-MM-DD HH:mm:ss";
